import { useTranslation } from "react-i18next";

import type { HaNSearchPerson, HaNTextRange } from "@lib/logic";
import type { BuildingWorkspaceReservation } from "@lib/store/src/data/timeslots/apiTypes";
import { Avatar } from "@molecules";

import { HaNSearchResultCell } from "./HaNSearchResultCell";

type PersonSearchResultProps = {
  person: HaNSearchPerson;
  // `null` when they aren't in the building today
  reservation: BuildingWorkspaceReservation | null;
  ranges: HaNTextRange[];
};

export const PersonSearchResult = ({ person, reservation, ranges }: PersonSearchResultProps) => {
  const { t } = useTranslation();

  const place = reservation
    ? [reservation.workspace.areaName, reservation.workspace.floorName].filter(Boolean).join(", ")
    : t("hereAndNow:NotInBuildingToday");

  return (
    <HaNSearchResultCell
      icon={
        <Avatar
          className="flex-none"
          size="large"
          user={{
            id: person.id,
            email: person.email,
            initials: person.initials ?? "",
            name: person.name,
            imageHash: person.imageHash,
          }}
        />
      }
      name={person.name}
      ranges={ranges}
      details={place}
    />
  );
};
